import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import prefix from '../../utils/prefix';
import './styles.sass';
var modifiers = prefix('checklist-item--');
export var CheckList = function CheckList(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "checklist"
  }, children);
};
CheckList.propTypes = {
  children: PropTypes.node
};
export var CheckListItem = function CheckListItem(_ref2) {
  var onChange = _ref2.onChange,
    small = _ref2.small,
    checked = _ref2.checked,
    children = _ref2.children,
    dataTest = _ref2.dataTest;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('checklist-item', modifiers({
      checked: checked,
      small: small
    })),
    role: "checkbox",
    "data-test": dataTest || 'checklist-item',
    "aria-checked": checked,
    onClick: function onClick() {
      return onChange && onChange(!checked);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "checklist-item__label"
  }, children));
};
CheckListItem.propTypes = {
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  small: PropTypes.bool,
  children: PropTypes.node,
  dataTest: PropTypes.string
};
//# sourceMappingURL=index.js.map
